import { ArmorType } from "../types/armor";

export const ARMOR_TYPES: Record<
  ArmorType,
  {
    name: string;
    costPerTon: number;
    tonnageConsumed: number;
    techLevel: number;
    maxProtection: (techLevel: number) => number;
    special?: string;
  }
> = {
  titaniumSteel: {
    name: "Titanium Steel Armor",
    costPerTon: 50000,
    tonnageConsumed: 0.025,
    techLevel: 7,
    maxProtection: (techLevel: number) => Math.min(techLevel, 9),
  },
  crystaliron: {
    name: "Crystaliron Armor",
    costPerTon: 200000,
    tonnageConsumed: 0.0125,
    techLevel: 10,
    maxProtection: (techLevel: number) => Math.min(techLevel, 13),
    special: "Reduced tonnage consumption",
  },
  bondedSuperdense: {
    name: "Bonded Superdense Armor",
    costPerTon: 500000,
    tonnageConsumed: 0.008,
    techLevel: 14,
    maxProtection: (techLevel: number) => techLevel,
    special: "Increased protection",
  },
  molecularBonded: {
    name: "Molecular Bonded Armor",
    costPerTon: 1500000,
    tonnageConsumed: 0.005,
    techLevel: 16,
    maxProtection: (techLevel: number) => techLevel + 4,
    special: "Superior protection and reduced weight",
  },
} as const;
